import React from "react";
import "./FooterLinkSlider.css"

export default function FooterLinkSlider() {
  const links = [
    {id:1, keyword:"Best Hotel Near Delhi Airport",link:"https://www.vhotelthegrandshoba.com/"},
    {id:4, keyword:"Corporate Hall Near Delhi Airport",link:"https://www.vhotelthegrandshoba.com/corporate"},
    {id:2, keyword:"Rooms Near Delhi Airport",link:"https://www.vhotelthegrandshoba.com/rooms"},
    {id:5, keyword:"Hotel Image Near Delhi Airport",link:"https://www.vhotelthegrandshoba.com/gallery"},
    {id:3, keyword:"Best Hotel Near Delhi Airport",link:"https://www.vhotelthegrandshoba.com/dine"},
    {id:6, keyword:"contact-us",link:"https://www.vhotelthegrandshoba.com/contact-us"},
    {id:7, keyword:"Hotels Near IGI Airport",link:"https://www.vhotelthegrandshoba.com/booking"},
  ];

  return (
    <div className="marquee-container">
      <div className="marquee">
        {links.map((text, index) => (
          <a key={index} href={text.link} className="marquee-item">
            {text.keyword}
            <span className="divider"> | </span>
          </a>
        ))}
      </div>
    </div>
  );
}
